var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6367 1.91699C11.6367 1.50278 11.9725 1.16699 12.3867 1.16699H17.5004C17.9146 1.16699 18.2504 1.50278 18.2504 1.91699V7.03063C18.2504 7.44484 17.9146 7.78063 17.5004 7.78063C17.0861 7.78063 16.7504 7.44484 16.7504 7.03063V2.66699H12.3867C11.9725 2.66699 11.6367 2.33121 11.6367 1.91699Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.03 1.38666C18.3229 1.67956 18.3229 2.15443 18.03 2.44732L11.8936 8.58368C11.6007 8.87658 11.1258 8.87658 10.833 8.58368C10.5401 8.29079 10.5401 7.81592 10.833 7.52303L16.9693 1.38666C17.2622 1.09377 17.7371 1.09377 18.03 1.38666Z",
    fill: "#146EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 5.39453H8.63636C9.05058 5.39453 9.38636 5.05874 9.38636 4.64453C9.38636 4.23032 9.05058 3.89453 8.63636 3.89453H3.18182C2.80208 3.89453 2.43789 4.04538 2.16937 4.3139C1.90085 4.58242 1.75 4.94661 1.75 5.32635V16.2354C1.75 16.6152 1.90085 16.9794 2.16937 17.2479C2.43789 17.5164 2.80208 17.6673 3.18182 17.6673H14.0909C14.4706 17.6673 14.8348 17.5164 15.1034 17.2479C15.3719 16.9794 15.5227 16.6152 15.5227 16.2354V10.7809C15.5227 10.3667 15.1869 10.0309 14.7727 10.0309C14.3585 10.0309 14.0227 10.3667 14.0227 10.7809V16.1673H3.25V5.39453Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/external-link-icon.bdaca9248e1970554c3495710aa93adc.svg";
export { ForwardRef as ReactComponent };